import { ListingItem } from "./search-model";
import SearchAgent from "./search-agent";
export default class SearchResults extends SearchAgent<ListingItem> {
    constructor(elementId: string, searchOptions: string, resultType: 'general' | 'news', perPage: number, filterButtonId: string) {
        super(elementId, searchOptions);
        this.searchMode = resultType;
        this.itemsToShow = perPage;
        this.filterButton = document.getElementById(filterButtonId) as HTMLButtonElement;
    }

    CreateItems(data: ListingItem, index: number) {
        const itemClone = this.searchResultItemTemplate.children[0].cloneNode(true) as HTMLElement;
        const itemWrapper = this.searchMode == "news" ? itemClone.querySelector<HTMLAnchorElement>(".card__div") : itemClone.querySelector<HTMLAnchorElement>(".card__link");
        const itemSuperTitle = itemClone.querySelector<HTMLElement>(".card__supertitle");
        const itemTitle = itemClone.querySelector<HTMLElement>(".card__title h3");
        const itemDescription = itemClone.querySelector<HTMLElement>(".card__description");
        const itemImage = itemClone.querySelector<HTMLImageElement>("img.card__media");
        const itemTag = itemClone.querySelector<HTMLElement>(".tag");
        const itemBreadcrumbs = itemClone.querySelector<HTMLElement>(".card__breadcrumb");
        const itemButton = itemClone.querySelector<HTMLAnchorElement>(".button");
        
        if (itemClone && itemWrapper && itemTitle) {
            itemWrapper.classList.toggle('pinned', data.Pinned && index == 0); // Only pin first pinned item
            itemWrapper.href = data.URL
            itemTitle.innerText = data.Title;
            if (itemSuperTitle) itemSuperTitle.innerText = data.Subtitle;
            if (itemDescription) itemDescription.innerText = data.Content;

            if (itemImage) {
                itemImage.src = data.Image.replace("~", "");
                itemImage.alt = data.ImageAltText == "" ? "" : data.ImageAltText;
            }
            if (itemButton) {
                itemButton.href = data.URL;
            }
            let tagContent = '';
            switch (data.ContentType) {
                case "News":
                    tagContent = data.Created
                    break;
                case "Document":
                    tagContent = data.FileInfo
                    itemWrapper.setAttribute('download', '')
                    break;
            }
            if (itemTag != null)
                itemTag.textContent = tagContent;

            if (itemBreadcrumbs != null)
                itemBreadcrumbs.innerHTML = data.Breadcrumbs;

            this.itemList.push(itemClone);
        }
    }
}